import React from 'react';
import { Box, keyframes } from '@mui/material';
import { useInstatDesign } from '../theme/instatDesign';

const shimmer = keyframes`
  0%   { background-position: -200px 0; }
  100% { background-position: calc(200px + 100%) 0; }
`;

/**
 * iOS-style skeleton — gentle shimmer, rounded.
 */
export default function Skeleton({
  width = '100%',
  height = 14,
  radius,
  variant = 'rect', // 'rect' | 'pill' | 'circle'
  sx = {},
}) {
  const d = useInstatDesign();
  const r =
    variant === 'circle' ? '50%'
    : variant === 'pill' ? `${d.radius.pill}px`
    : `${radius != null ? radius : d.radius.md}px`;

  return (
    <Box
      sx={{
        width,
        height,
        borderRadius: r,
        background: `linear-gradient(
          90deg,
          rgba(120,120,128,0.08) 0%,
          rgba(120,120,128,0.16) 50%,
          rgba(120,120,128,0.08) 100%
        )`,
        backgroundSize: '200px 100%',
        backgroundRepeat: 'no-repeat',
        animation: `${shimmer} 1.3s ease-in-out infinite`,
        ...sx,
      }}
    />
  );
}
